<template>
  <div class="panel-body">
    <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
    
    <!-- Sección de la tabla -->
    <div v-if="mostrarTabla">
      <b-row class="descargarexcel">
        <b-col offset="10">
          <b-button @click="nuevo()" class="boton-busccar botonexcel">
            <b-icon class="iconoexcel" icon="person-plus" aria-hidden="true"></b-icon>Nuevo Cliente
          </b-button>
        </b-col>
      </b-row>

      <!-- Filtros de búsqueda -->
      <b-row class="mb-3 mt-3 filtros-busqueda">
        <b-col md="4">
          <b-form-group label="Buscar por Identificación" label-for="filtroIdentificacion">
            <b-form-input
              id="filtroIdentificacion"
              v-model="filtroIdentificacion"
              placeholder="Número de identificación..."
              @keyup.enter="buscar()"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Buscar por Nombre" label-for="filtroNombre">
            <b-form-input
              id="filtroNombre"
              v-model="filtroNombre"
              placeholder="Nombre del cliente..."
              @keyup.enter="buscar()"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4" class="d-flex align-items-end mb-3">
          <b-button variant="primary" @click="buscar()" class="mr-2">
            <b-icon icon="search"></b-icon> Buscar
          </b-button>
          <b-button variant="outline-secondary" @click="limpiarFiltros()">
            <b-icon icon="x-circle"></b-icon> Limpiar
          </b-button>
        </b-col>
      </b-row>
      
      <b-table responsive id="my-tablems"
              head-variant="light" striped :items="items" :fields="fields">
              <template #cell(Acciones)="row">
                  <b-row class="acciones">
                      <b-col >
                          <b-button id="tooltip-target-1" variant="primary"
                              @click="verCliente(row.item)"><b-icon class="iconobuscar"
                                  icon="eye-fill" /></b-button>
                          <b-tooltip target="tooltip-target-1" triggers="hover" placement="right">
                              Ver más
                          </b-tooltip>
                      </b-col>
                      <b-col >
                          <b-button  id="tooltip-target-2" variant="info"
                              @click="editarCliente(row.item)"><b-icon class="iconobuscar"
                                  icon="pencil-square" /></b-button>
                          <b-tooltip target="tooltip-target-2" triggers="hover">
                              Editar
                          </b-tooltip>
                      </b-col>
                      <b-col >
                          <b-button  id="tooltip-target-3" variant="danger"
                              @click="confirmarEliminacion(row.item.id, row.item.nombre_cliente)"><b-icon class="iconobuscar"
                                  icon="trash" /></b-button>
                          <b-tooltip target="tooltip-target-3" triggers="hover">
                              Eliminar
                          </b-tooltip>
                      </b-col>
                  </b-row>
              </template>
      </b-table>
      
      <div class="spinerr" v-if="esperandoInfo == true">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
      <div class="divnodata" v-if=" items.length== 0 && esperandoInfo != true">
          <b-img class="bannernodata" src="/img/banner.jpg"></b-img>
          <p>No se encontró información</p>
      </div>
      
      <b-row>
          <b-col class="nombrelabel" md="2" offset-md="9">
              <label for="selectPage">Registros por página:</label>
          </b-col>
          <b-col md="1">
              <b-form-select class="selectpage" @input="paginacion(currentPage = 1)" v-model="perPage"
                  :options="pageOptions" />
          </b-col>
      </b-row>
      <b-pagination class="justify-content-center" v-model="currentPage" :total-rows="rows" :per-page="perPage"
          @input="paginacion(currentPage)" aria-controls="my-tablems"></b-pagination>
    </div>

    <!-- Sección del formulario -->
    <div v-if="mostrarFormulario">
      <b-row class="mb-3">
        <b-col>
          <b-button variant="secondary" @click="volverATabla()">
            <b-icon icon="arrow-left"></b-icon> Volver
          </b-button>
        </b-col>
      </b-row>
      
      <b-card>
        <template #header>
          <h4 class="mb-0">
            <span v-if="modoFormulario === 'crear'">Crear Nuevo Cliente</span>
            <span v-else-if="modoFormulario === 'editar'">Editar Cliente</span>
            <span v-else>Ver Cliente</span>
          </h4>
        </template>
        
        <b-form @submit.prevent="guardarCliente">
          <b-row>
            <b-col md="6">
              <b-form-group label="Tipo de Identificación" label-for="tipo_identificacion">
                <b-form-select 
                  id="tipo_identificacion"
                  v-model="formData.tipo_de_identificacion" 
                  :disabled="modoFormulario === 'ver'"
                  required>
                  <option value="">Seleccione...</option>
                  <option value="CC">Cédula de Ciudadanía</option>
                  <option value="NIT">NIT</option>
                  <option value="CE">Cédula de Extranjería</option>
                  <option value="TI">Tarjeta de Identidad</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Número de Identificación" label-for="numero_identificacion">
                <b-form-input 
                  id="numero_identificacion"
                  v-model="formData.numero_de_identificacion" 
                  :disabled="modoFormulario === 'ver'"
                  required>
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="6">
              <b-form-group label="Nombre del Cliente" label-for="nombre_cliente">
                <b-form-input 
                  id="nombre_cliente"
                  v-model="formData.nombre_cliente" 
                  :disabled="modoFormulario === 'ver'"
                  required>
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Tipo de Cliente" label-for="tipo_cliente">
                <b-form-select 
                  id="tipo_cliente"
                  v-model="formData.tipo_cliente" 
                  :disabled="modoFormulario === 'ver'"
                  required>
                  <option value="">Seleccione...</option>
                  <option value="IPS">IPS</option>
                  <option value="Clínica">Clínica</option>
                  <option value="Hospital">Hospital</option>
                  <option value="EPS">EPS</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="6">
              <b-form-group label="Departamento" label-for="departamento">
                <b-form-select 
                  id="departamento"
                  v-model="formData.departamento" 
                  :disabled="modoFormulario === 'ver'"
                  @change="onDepartamentoChange">
                  <option value="">Seleccione departamento...</option>
                  <option 
                    v-for="depto in departamentos" 
                    :key="depto.id" 
                    :value="depto.id">
                    {{ depto.name }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Municipio" label-for="municipio">
                <b-form-select 
                  id="municipio"
                  v-model="formData.municipio" 
                  :disabled="modoFormulario === 'ver' || !formData.departamento">
                  <option value="">Seleccione municipio...</option>
                  <option 
                    v-for="municipio in municipios" 
                    :key="municipio.id" 
                    :value="municipio.id">
                    {{ municipio.name }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="12">
              <b-form-group label="Dirección" label-for="direccion">
                <b-form-input 
                  id="direccion"
                  v-model="formData.direccion" 
                  :disabled="modoFormulario === 'ver'">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="6">
              <b-form-group label="Celular" label-for="celular">
                <b-form-input 
                  id="celular"
                  v-model="formData.celular" 
                  :disabled="modoFormulario === 'ver'"
                  type="number">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Correo Electrónico" label-for="correo">
                <b-form-input 
                  id="correo"
                  v-model="formData.correo_electronico" 
                  :disabled="modoFormulario === 'ver'"
                  type="email">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="6">
              <b-form-group label="Perfil" label-for="perfil">
                <b-form-select 
                  id="perfil"
                  v-model="formData.perfil" 
                  disabled>
                  <option value="2">Institución</option>
                </b-form-select>
                <small class="text-muted">El perfil siempre será "Institución" para los clientes</small>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Cantidad de Usuarios" label-for="cantidad_usuarios">
                <b-form-input 
                  id="cantidad_usuarios"
                  v-model="formData.cantidad_de_usuarios" 
                  :disabled="modoFormulario === 'ver'"
                  type="number"
                  min="1">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="6">
              <b-form-group label="Barrio" label-for="barrio">
                <b-form-input 
                  id="barrio"
                  v-model="formData.barrio" 
                  :disabled="modoFormulario === 'ver'">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Actividad" label-for="actividad">
                <b-form-input 
                  id="actividad"
                  v-model="formData.actividad" 
                  :disabled="modoFormulario === 'ver'">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row v-if="modoFormulario !== 'ver'">
            <b-col class="text-right">
              <b-button variant="secondary" @click="volverATabla()" class="mr-2">
                Cancelar
              </b-button>
              <b-button 
                variant="primary" 
                type="submit" 
                :disabled="loading">
                <b-spinner v-if="loading" small></b-spinner>
                {{ modoFormulario === 'crear' ? 'Crear Cliente' : 'Guardar Cambios' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Vue from 'vue'
import HeaderGeneral from "../../components/HeaderGeneral.vue";
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import "vue-form-generator/dist/vfg-core.css";

Vue.use(VueFormGenerator)
//
const config = RepositoryFactory.get("config");
const clientes = RepositoryFactory.get("clientes");
export default {
  components: {
    "vue-form-generator": VueFormGenerator.component,
    HeaderGeneral
  },
  data() {
    return {
      vista: "Clientes",
      proveniente: " - Gestión de clientes  ",
      carpeta: "Configuración",
      perPage: 5,
      pageOptions: [3, 5, 10, 15, 20],
      currentPage: 1,
      esperandoInfo: false,
      items:[],
      filtroIdentificacion: '',
      filtroNombre: '',
      // Variables para departamentos y municipios
      valoresdepartamentos: [],
      departamentos: [],
      municipios: [],
      totalRows: 0,
      fields: [
                { key: 'tipo_de_identificacion', label: 'Tipo ID', sortable: true }, 
                { key: 'numero_de_identificacion', label: 'N° Identificación', sortable: true }, 
                { key: 'nombre_cliente', label: 'Nombre Cliente', sortable: true }, 
                { key: 'tipo_cliente', label: 'Tipo Cliente', sortable: true }, 
                { key: 'departamento', label: 'Departamento', sortable: true },
                { key: 'municipio', label: 'Municipio', sortable: true },
                { key: 'celular', label: 'Celular', sortable: true },
                { key: 'correo_electronico', label: 'Email', sortable: true },
                // { key: 'perfil', label: 'Perfil', sortable: true },
                { key: 'cantidad_de_usuarios', label: 'Usuarios', sortable: true },
                'Acciones'],
      // Variables para el formulario
      mostrarFormulario: false,
      mostrarTabla: true,
      modoFormulario: 'crear', // 'crear', 'editar', 'ver'
      clienteActual: {},
      formData: {
        tipo_de_identificacion: '',
        numero_de_identificacion: '',
        nombre_cliente: '',
        tipo_cliente: '',
        departamento: '',
        municipio: '',
        direccion: '',
        celular: '',
        correo_electronico: '',
        cantidad_de_usuarios: 1,
        barrio: '',
        actividad: '',
        perfil: '2' // Siempre será "Institución" por defecto
      },
      errors: {},
      loading: false
    }
  },
  mounted() {

    
  },
  computed: {
        rows() {
            return this.totalRows || this.items.length
        },
    },
 async created() {
    try {
      this.consultarClientes();
      
      // Cargar departamentos y municipios
      const response = await config.listasDesplegablesXId({
        "nombre_entidad": "listados",
        "id":2
      });
      
      const listaTiposDepartamentos = response.find(item => item.data.nombre_lista === "divipola_colombia");
      this.valoresdepartamentos = listaTiposDepartamentos.data.rows;

      // Procesar departamentos para el select (eliminar duplicados)
      var departamentos = this.valoresdepartamentos.map(x => {
        return {
          id: x.codigo_departamento,
          name: x.nombre_departamento
        }
      }).filter(
        (obj, index, self) =>
          index ===
          self.findIndex((o) => o.id === obj.id && o.name === obj.name)
      );
      
      this.departamentos = departamentos;
    } catch (error) {
      console.error("Error cargando departamentos:", error);
    }
  },
  methods: {
   
    paginacion(currentPage) {
            this.currentPage = currentPage;
            this.consultarClientes();
        },
        nuevo(){
          this.modoFormulario = 'crear';
          this.limpiarFormulario();
          this.mostrarFormulario = true;
          this.mostrarTabla = false;
        },
    buscar() {
      this.currentPage = 1;
      this.consultarClientes();
    },
    limpiarFiltros() {
      this.filtroIdentificacion = '';
      this.filtroNombre = '';
      this.currentPage = 1;
      this.consultarClientes();
    },
    async consultarClientes() {
        try {
          this.esperandoInfo = true;
          
          // Configurar condiciones WHERE
          var andConditions = [
            {
              "id": {
                "notEquals": ""
              }
            }
          ];

          // Agregar filtro por identificación si tiene valor
          if (this.filtroIdentificacion && this.filtroIdentificacion.trim() !== '') {
            andConditions.push({
              "numero_de_identificacion": {
                "iLike": "%" + this.filtroIdentificacion.trim() + "%"
              }
            });
          }

          // Agregar filtro por nombre si tiene valor
          if (this.filtroNombre && this.filtroNombre.trim() !== '') {
            andConditions.push({
              "nombre_cliente": {
                "iLike": "%" + this.filtroNombre.trim() + "%"
              }
            });
          }

          var where = [{
            "AND": andConditions
          }];

          // Configurar relaciones para obtener departamentos y municipios
          var relaciones = [{
            "entidad": {
              "nombre": "listados",
              "columna_relacion": {
                "rows": "codigo_departamento"
              },
              "columna_relacion_principal": "departamento",
              "order": {
                "column": "col",
                "type": "asc"
              },
              "size": 50,
              "page": 1,
              "where": [{
                "AND": [{
                  "nombre_lista": {
                    "iLike": "divipola_colombia"
                  }
                }]
              }]
            }
          }];

          var params = {
            "nombreEntidad": "entidad_cliente",
            "idVersion": 2,
            "column": "id",
            "type": "desc",
            "size": this.perPage,
            "page": this.currentPage
          };

          const response = await config.getMetaData(params, where, relaciones);
          this.esperandoInfo = false;
          
          if (response && response.message && response.message.rows) {
            this.totalRows = response.message.count;
            this.items = response.message.rows.map((x) => {
              var dataTable = x.data;
              
              // Buscar el nombre del departamento en las relaciones
              const departamentoBuscado = dataTable.listados?.flat().find(item => 
                item.row_data && 
                item.row_data.codigo_departamento === dataTable.departamento && 
                item.nombre_lista === "divipola_colombia"
              );
              const departamentoNombre = departamentoBuscado ? departamentoBuscado.row_data.nombre_departamento : dataTable.departamento;
              
              // Buscar el nombre del municipio en las relaciones
              const municipioBuscado = dataTable.listados?.flat().find(item => 
                item.row_data && 
                item.row_data.codigo_municipio === dataTable.municipio && 
                item.nombre_lista === "divipola_colombia"
              );
              const municipioNombre = municipioBuscado ? municipioBuscado.row_data.nombre_municipio : dataTable.municipio;

              return {
                'id': dataTable.id || '',
                'tipo_de_identificacion': dataTable.tipo_de_identificacion,
                'numero_de_identificacion': dataTable.numero_de_identificacion,
                'nombre_cliente': dataTable.nombre_cliente,
                'tipo_cliente': dataTable.tipo_cliente,
                'departamento': departamentoNombre,
                'municipio': municipioNombre,
                'direccion': dataTable.direccion,
                'celular': dataTable.celular,
                'correo_electronico': dataTable.correo_electronico,
                'perfil': dataTable.perfil,
                'cantidad_de_usuarios': dataTable.cantidad_de_usuarios,
                'barrio': dataTable.barrio || '',
                'actividad': dataTable.actividad || '',
                'createat': dataTable.createat || '',
                'updateat': dataTable.updateat || '',
                // Guardar los códigos originales para edición
                'departamento_codigo': dataTable.departamento,
                'municipio_codigo': dataTable.municipio
              };
            });
          } else {
            this.items = [];
            this.totalRows = 0;
          }
          console.log("this.items", this.items);
        } catch (error) {
          this.esperandoInfo = false;
          this.items = [];
          this.totalRows = 0;
          console.error("Error consultando clientes:", error);
        }
    },
    verCliente(cliente) {
      this.modoFormulario = 'ver';
      this.cargarDatosFormulario(cliente);
      this.mostrarFormulario = true;
      this.mostrarTabla = false;
    },
    
    editarCliente(cliente) {
      this.modoFormulario = 'editar';
      this.cargarDatosFormulario(cliente);
      this.mostrarFormulario = true;
      this.mostrarTabla = false;
    },
    
    volverATabla() {
      this.mostrarFormulario = false;
      this.mostrarTabla = true;
      this.limpiarFormulario();
    },
    
    limpiarFormulario() {
      this.formData = {
        tipo_de_identificacion: '',
        numero_de_identificacion: '',
        nombre_cliente: '',
        tipo_cliente: '',
        departamento: '',
        municipio: '',
        direccion: '',
        celular: '',
        correo_electronico: '',
        cantidad_de_usuarios: 1,
        barrio: '',
        actividad: '',
        perfil: '2' // Siempre será "Institución"
      };
      this.clienteActual = {};
    },
    
    cargarDatosFormulario(cliente) {
      this.clienteActual = { ...cliente };
      this.formData = {
        tipo_de_identificacion: cliente.tipo_de_identificacion || '',
        numero_de_identificacion: cliente.numero_de_identificacion || '',
        nombre_cliente: cliente.nombre_cliente || '',
        tipo_cliente: cliente.tipo_cliente || '',
        departamento: cliente.departamento_codigo || cliente.departamento || '',
        municipio: cliente.municipio_codigo || cliente.municipio || '',
        direccion: cliente.direccion || '',
        celular: cliente.celular || '',
        correo_electronico: cliente.correo_electronico || '',
        cantidad_de_usuarios: cliente.cantidad_de_usuarios || 1,
        barrio: cliente.barrio || '',
        actividad: cliente.actividad || '',
        perfil: '2' // Siempre forzar a "Institución"
      };
      
      // Si hay departamento, cargar municipios correspondientes
      if (cliente.departamento_codigo || cliente.departamento) {
        this.municipioXDepartamento(cliente.departamento_codigo || cliente.departamento);
      }
    },
    
    async guardarCliente() {
      try {
        this.loading = true;
        
        if (this.modoFormulario === 'crear') {
          const response = await clientes.guardarEntidadCliente(this.formData);
          if (response) {
            this.$bvToast.toast('Cliente creado exitosamente', {
              title: 'Éxito',
              variant: 'success',
              autoHideDelay: 3000
            });
            this.volverATabla();
            this.consultarClientes();
          }else{
            this.$bvToast.toast('Error al crear el cliente', {
              title: 'Error',
              variant: 'danger',
              autoHideDelay: 3000
            });
          }
        } else if (this.modoFormulario === 'editar') {
          const params = {
            ...this.formData,
            id_metadata: this.clienteActual.id
          };
          const response = await clientes.editarEntidadCliente(params);
          if (response) {
            this.$bvToast.toast('Cliente actualizado exitosamente', {
              title: 'Éxito',
              variant: 'success',
              autoHideDelay: 3000
            });
            this.volverATabla();
            this.consultarClientes();
          }else{
            this.$bvToast.toast('Error al actualizar el cliente', {
              title: 'Error',
              variant: 'danger',
              autoHideDelay: 3000
            });
          }
        }
      } catch (error) {
        console.error('Error guardando cliente:', error);
        this.$bvToast.toast('Error al guardar el cliente', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 3000
        });
      } finally {
        this.loading = false;
      }
    },

    datosUser(id, datos,editar){
      var carpeta="Cliente";
      this.$router.push({ name: 'clientes-form', params: { myParam: datos, id: id, editable: editar, carpeta: carpeta } });
    },
    
    // Método para eliminar un cliente
    async eliminarCliente(id) {
      try {
        // Aquí implementarías la lógica de eliminación si existe el endpoint
        // const response = await clientes.eliminarEntidadCliente({id: id});
        console.log("Eliminar cliente con ID:", id);
        // Recargar la lista después de eliminar
        this.consultarClientes();
      } catch (error) {
        console.error("Error eliminando cliente:", error);
      }
    },

    // Método para confirmar eliminación
    confirmarEliminacion(id, nombre) {
      if (confirm(`¿Está seguro que desea eliminar el cliente "${nombre}"?`)) {
        this.eliminarCliente(id);
      }
    },

    // Método para filtrar municipios por departamento
    async municipioXDepartamento(codeDepartment) {
      var municipios = this.valoresdepartamentos.filter(x => x.codigo_departamento == codeDepartment).map(x => {
        return {
          id: x.codigo_municipio,
          name: x.nombre_municipio
        }
      });
      this.municipios = municipios;
    },

    // Método que se ejecuta cuando cambia el departamento
    onDepartamentoChange() {
      // Limpiar municipio cuando cambia el departamento
      this.formData.municipio = '';
      // Cargar municipios del nuevo departamento
      if (this.formData.departamento) {
        this.municipioXDepartamento(this.formData.departamento);
      } else {
        this.municipios = [];
      }
    },
  },
}
</script>
<style>
.fa,
.fas {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
}

.form-group.disabled>label {
  color: #212529 !important;
  font-style: normal !important;
}

/* a continuación hay que poner la instrucción concreta de cada icono. fijaros que en realidad mediante el pseudo-selector ::before introducimos contenido delante de la etiqueta*/

.fa-thumbs-down:before {
  content: "\f165";
}

.nombre {
  transform: uppercase !important;
}

.alertared {
  margin-top: 2%;
}

.dele {
  color: white;
  background: var(--blue-violet);
  border-radius: 5px;
  zoom: 1.8;
  padding: 2%;
}

.hed {
  font-family: var(--font-family-poppins);

  padding: 1%;
  text-align: center;
}

.dato {
  border-top: 1px solid gainsboro;
}

.contenidotabla {
  background: white;
  margin: 0%;
  border-radius: 8px;
  border: 1px solid gainsboro;
  padding: 1%;
  margin-top: 3%;
}

.tabla {
  color: var(--blue-violet);
  font-weight: 600;
  border-bottom: 1px solid gainsboro;
}

.close {
  background: transparent;
  border: none;
  color: white;
  zoom: 1.5;
  margin-top: -0.6%;
  float: right;
}

.alert-dismissible {
  padding-right: 1rem !important;
}

.alert-danger {
  --bs-alert-color: white !important;
  --bs-alert-bg: red !important;
  --bs-alert-border-color: #f5c2c7;
  font-family: var(--font-family-poppins);
  font-size: 14px;
}

.icono {
  zoom: 2;
  margin-left: -32%;
  margin-top: -8%;

}

.vue-form-generator .hint {
  font-style: italic;
  font-size: 10px;
}

.has-error>.fiel-wrap {
  border: 1px solid red;
}

.errors {
  color: red;
  font-size: 11px !important;
}

.panel-body {
  margin: 2% 5%;
  font-family: var(--font-family-poppins);
}

.my-4 {
  color: var(--blue-violet);
}

.regis {
  font-size: 33px !important;
  text-align: center !important;
  font-weight: 600 !important;
  color: var(--blue-violet);
}

.centro {
  text-align: center;
}

hr {
  opacity: 1 !important;
}

.botonregidtro {
  width: 20%;
  margin-top: 2%;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  border-color: transparent !important;
  border-color: transparent !important;
}

.botonadd {
  width: 50px;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  border-color: transparent !important;
  border-color: transparent !important;
  position: absolute;
  right: 5%;
  top: 77%;
}</style>